/** Map a single search box to API name/email query params. */
export const buildNameEmailSearchParams = (query) => {
  const trimmed = (query || "").trim();
  if (!trimmed) return {};
  if (trimmed.includes("@")) return { email: trimmed };
  return { name: trimmed, email: trimmed };
};
